import {storeInstance} from '@aofl/store/dist/legacy';
import {deepAssign} from '@aofl/object-utils';
import {sdoNs} from '../../constants-enumerate';

const sdo = {
  namespace: sdoNs.COLLAPSE,
  mutations: {
    init(payload = {}) {
      return payload;
    },
    addGroup(subState, {groupId}) {
      return Object.assign({}, subState, {
        [String(groupId)]: {}
      });
    },
    removeGroup(subState, {groupId}) {
      const nextSubState = Object.assign({}, subState);
      delete nextSubState[groupId];
      return nextSubState;
    },
    add(subState, {groupId = 'ungrouped', id, open = false}) {
      if (typeof subState[groupId] === 'undefined') {
        subState = sdo.mutations.addGroup(subState, {groupId});
      }

      return deepAssign(subState, groupId, {
        [String(id)]: open
      });
    },
    remove(subState, {groupId, id}) {
      const nextSubState = Object.assign({}, subState);
      delete nextSubState[groupId][id];
      if (Object.keys(nextSubState[groupId]).length === 0) {
        delete nextSubState[groupId];
      }

      return nextSubState;
    },
    close(subState, {groupId, id}) {
      return deepAssign(subState, groupId, {
        [id]: false
      });
    },
    closeAll(subState, {groupId}) {
      const nextSubState = {
        [groupId]: {}
      };
      for (const key in subState[groupId]) {
        /* istanbul ignore next */
        if (!subState[groupId].hasOwnProperty(key)) continue;
        nextSubState[groupId][key] = false;
      }

      return Object.assign({}, subState, nextSubState);
    },
    open(subState, {groupId = 'ungrouped', id}) {
      if (groupId !== 'ungrouped') {
        subState = sdo.mutations.closeAll(subState, {groupId});
      }

      return deepAssign(subState, groupId, {
        [id]: true
      });
    }
  }
};

storeInstance.addState(sdo);

export {
  sdo
};
